import { z } from "zod";
import { ApiError } from "@softmax/observatory-client/transport";
import type {
  WikiEditConflictResponse,
  WikiPagePublic,
} from "@softmax/observatory-client/types";

const conflictDetail = z.object({
  type: z.literal("wiki_edit_conflict"),
  current_revision_id: z.string(),
  current_body: z.string(),
});

export function titleFromSlug(slug: string): string {
  const spaced = (slug.split("/").at(-1) ?? slug).replace(/-/g, " ");
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

export function editConflict(
  error: unknown,
): WikiEditConflictResponse["detail"] | null {
  if (!(error instanceof ApiError) || error.status !== 409) return null;

  const parsed = conflictDetail.safeParse(error.detail);
  return parsed.success ? parsed.data : null;
}

export type WikiEditConflict = WikiEditConflictResponse["detail"] & {
  readonly baseBody: string;
  readonly proposedBody: string;
};

export function wikiDraft({
  page,
  pageSlug,
}: {
  readonly page: WikiPagePublic | null;
  readonly pageSlug: string;
}) {
  return {
    title: page?.title ?? titleFromSlug(pageSlug),
    body: page?.current_revision.body ?? "",
    note: "",
  };
}
